// The stand-in Instagram reports as the author of hashtag-sourced media. There is no real user
// behind it, so anything keyed on a handle has to treat it as absent.
export const IG_HASHTAG_USER = 'IG-HASHTAG-USER';
